import {axios} from "../../config/axios"

export const notificationMessagesAPI = {

  /**
   * @returns {Promise<*>}
   * @param { { campaign_id: String } | { auto_campaign_id: String } } params
   */
  async fetchNotifications(params) {
    return axios.get(`/api/v3/message_templates`, { params })
                .then(resp => resp.data)
  },

  /**
   * @param id
   * @param { { campaign_id: String } | { auto_campaign_id: String } } params
   * @returns {Promise<*>}
   */
  likeMessage(id, params) {
    return axios.post(`/api/v3/message_templates/${id}/like`, null, { params });
  },

  /**
   * @param id
   * @param { { campaign_id: String } | { auto_campaign_id: String } } params
   * @returns {Promise<*>}
   */
  unlikeMessage(id, params) {
    return axios.post(`/api/v3/message_templates/${id}/unlike`, null, { params });
  },

  /**
   * @param id
   * @param { { campaign_id: String } | { auto_campaign_id: String } } params
   * @returns {Promise<*>}
   */
  deleteMessage(id, params) {
    return axios.post(`/api/v3/message_templates/${id}/invisible`, null, { params });
  },

  /**
   * @param id
   * @param { { campaign_id: String } | { auto_campaign_id: String } } params
   * @returns {Promise<*>}
   */
  undoDeleteMessage(id, params) {
    return axios.post(`/api/v3/message_templates/${id}/visible`, null, { params });
  },

}
